var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCreatePage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 32,
    viewBox: "0 0 116 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7749_20100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6032 32C7.37349 32 5.25858 32 3.66668 31.1249C2.49016 30.478 1.52195 29.51 0.875153 28.3333C0 26.7414 0 24.6265 0 20.3968V11.6032C0 7.37349 0 5.25858 0.875153 3.66668C1.52195 2.49016 2.49016 1.52195 3.66668 0.875153C5.25858 0 7.37349 0 11.6032 0H20.3968C24.6265 0 26.7414 0 28.3333 0.875153C29.51 1.52195 30.478 2.49016 31.1249 3.66668C32 5.25858 32 7.37349 32 11.6032V20.3968C32 24.6265 32 26.7414 31.1249 28.3333C30.478 29.51 29.51 30.478 28.3333 31.1249C26.7414 32 24.6265 32 20.3968 32H11.6032Z",
    fill: "url(#paint0_linear_7749_20100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 22.507V9H43.9431C47.1269 9 48.7477 10.2156 48.7477 12.454C48.7477 13.824 48.1495 14.7502 46.9724 15.2132C48.6513 15.7149 49.5195 16.8533 49.5195 18.59C49.5195 21.1756 47.6093 22.507 43.9431 22.507H38ZM41.2803 19.9022H43.9431C45.4481 19.9022 46.1428 19.3811 46.1428 18.2812C46.1428 17.2007 45.4481 16.7183 43.9431 16.7183H41.2803V19.9022ZM41.2803 14.2291H43.9431C44.9272 14.2291 45.371 13.7854 45.371 12.8592C45.371 11.9716 44.9272 11.6049 43.9431 11.6049H41.2803V14.2291Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.293 22.8161C52.6302 22.8161 50.8164 20.7323 50.8164 17.7028C50.8164 14.5962 52.7073 12.5508 55.293 12.5508C56.7016 12.5508 57.8014 13.1489 58.5154 14.2103V12.8596H61.6028V22.5074H58.5154V21.1953C57.8014 22.2373 56.7016 22.8161 55.293 22.8161ZM54.0002 17.6834C54.0002 19.2078 54.9071 20.2112 56.2578 20.2112C57.6085 20.2112 58.5154 19.2078 58.5154 17.6834C58.5154 16.1591 57.6085 15.1558 56.2578 15.1558C54.9071 15.1558 54.0002 16.1591 54.0002 17.6834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3789 22.5072V20.2882L67.7397 15.2712H63.6683V12.8594H71.869V14.2679L66.7363 20.2882H72.062V22.5072H63.3789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4395 22.8161C74.7767 22.8161 72.9629 20.7323 72.9629 17.7028C72.9629 14.5962 74.8538 12.5508 77.4395 12.5508C78.8481 12.5508 79.9479 13.1489 80.6619 14.2103V12.8596H83.7492V22.5074H80.6619V21.1953C79.9479 22.2373 78.8481 22.8161 77.4395 22.8161ZM76.1466 17.6834C76.1466 19.2078 77.0536 20.2112 78.4042 20.2112C79.7549 20.2112 80.6619 19.2078 80.6619 17.6834C80.6619 16.1591 79.7549 15.1558 78.4042 15.1558C77.0536 15.1558 76.1466 16.1591 76.1466 17.6834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8458 22.8161C87.183 22.8161 85.3691 20.7323 85.3691 17.7028C85.3691 14.5962 87.2602 12.5508 89.8458 12.5508C91.2544 12.5508 92.3542 13.1489 93.0681 14.2103V12.8596H96.1555V22.5074H93.0681V21.1953C92.3542 22.2373 91.2544 22.8161 89.8458 22.8161ZM88.553 17.6834C88.553 19.2078 89.4598 20.2112 90.8106 20.2112C92.1613 20.2112 93.0681 19.2078 93.0681 17.6834C93.0681 16.1591 92.1613 15.1558 90.8106 15.1558C89.4598 15.1558 88.553 16.1591 88.553 17.6834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.424 22.8164C110.182 22.8164 109.835 20.5781 109.835 19.1502V15.4648H107.848V12.8599H109.835V10.1777H112.922V12.8599H115.72V15.4648H112.922V19.1502C112.922 19.7485 113.154 20.2115 114.041 20.2115C114.62 20.2115 114.988 20.0186 115.508 19.6906V22.3341C115.026 22.6429 114.331 22.8164 113.424 22.8164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0508 22.4918V12.8438H101.138V14.4261C101.601 13.2491 102.585 12.5352 103.897 12.5352C105.595 12.5352 106.734 13.77 106.734 15.7575C106.734 16.6258 106.522 17.5135 106.155 18.266H102.971C103.357 17.552 103.589 16.9346 103.589 16.3557C103.589 15.6225 103.222 15.14 102.624 15.14C101.775 15.14 101.138 16.1435 101.138 17.7064V22.4918H98.0508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5609 26.5825H17.6128C23.6062 26.5825 26.0802 20.5086 23.2009 15.8025C21.1641 12.4731 17.0272 12.3135 16.4536 15.4293C16.4045 15.7423 16.4045 16.0667 16.4536 16.3797C17.0272 19.4955 21.1641 19.3358 23.2009 16.0066C26.0802 11.3004 23.6062 5.22656 17.6128 5.22656H11.5609C9.26884 5.22656 7.52637 6.86378 7.52637 9.3196V15.6346V22.4895C7.52637 24.9452 9.26884 26.5825 11.5609 26.5825Z",
    stroke: "white",
    strokeWidth: 2.33888
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6124 5.22656C23.6057 5.22656 26.0797 11.3004 23.2005 16.0066C21.1636 19.3358 17.0269 19.4955 16.4531 16.3797",
    stroke: "url(#paint1_linear_7749_20100)",
    strokeWidth: 2.33888
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6124 26.582C23.6057 26.582 26.0797 20.5081 23.2005 15.802C21.1636 12.4726 17.0269 12.313 16.4531 15.4288",
    stroke: "white",
    strokeWidth: 2.33888
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7749_20100",
    x1: 10.5388,
    y1: 8.87953,
    x2: 16.0001,
    y2: 29.6284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C700CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7749_20100",
    x1: 22.9759,
    y1: 11.3808,
    x2: 19.0025,
    y2: 17.3682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371814,
    stopColor: "#EACAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481371,
    stopColor: "#D494D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618931,
    stopColor: "#E9C8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7749_20100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.788,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCreatePage);
export default __webpack_public_path__ + "static/media/logo-create-page.d4a7537d8d62443bd62feb2197a14893.svg";
export { ForwardRef as ReactComponent };